import { render, staticRenderFns } from "./ques-outerForm.vue?vue&type=template&id=38033b36&scoped=true"
import script from "./ques-outerForm.vue?vue&type=script&lang=js"
export * from "./ques-outerForm.vue?vue&type=script&lang=js"
import style0 from "./ques-outerForm.vue?vue&type=style&index=0&id=38033b36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38033b36",
  null
  
)

export default component.exports